const isNode = false;
const isBrowser = true;
const enforceServerSide = () => {
	throw new Error(
		'You are attempting to use code in the browser that has been ' +
			'designated server-side only. Such activity is known by ' +
			'the state of California to lead to usage of the dark side ' +
			'of the Force.'
	);
};

module.exports = {
	isNode,
	isBrowser,
	enforceServerSide
};
